export default {
      id: "facebook-usage",
      viewBox: "0 0 8 14",
      url: "../../assets/" + "sprite.svg#facebook-usage",
      toString: function () {
        return this.url;
      }
    }